export function formatMoneyMinor(amountMinor, currencyCode, locale) {
  const currency = currencyCode || "NGN";
  const value = Number(amountMinor || 0) / 100;
  try {
    return new Intl.NumberFormat(locale, {
      currency,
      maximumFractionDigits: currency === "NGN" ? 0 : 2,
      style: "currency",
    }).format(value);
  } catch {
    return `${currency} ${value.toLocaleString(locale, { maximumFractionDigits: 2 })}`;
  }
}

export function formatMoneyTotals(totals, fallbackCurrency = "NGN", locale) {
  if (!Array.isArray(totals) || totals.length === 0) {
    return formatMoneyMinor(0, fallbackCurrency, locale);
  }
  return totals
    .map((total) => formatMoneyMinor(total.amountMinor, total.currencyCode, locale))
    .join(" · ");
}

export function amountForCurrency(amounts, currencyCode) {
  return Number(
    (amounts || []).find((amount) => amount.currencyCode === currencyCode)?.amountMinor || 0,
  );
}

export function buildRevenueChartData(series, currencyCode) {
  return (series || []).map((point) => ({
    date: point.date,
    value: amountForCurrency(point.amounts, currencyCode) / 100,
  }));
}
